<template>
  <div class="quick-search-result flex flex-column">
    <div class="top-line flex justify-content-between align-items-center">
      <Skeleton width="35%" height="1rem" class="bg-gray-darker" />
      <Skeleton width="30%" height="1rem" class="bg-gray-dark" />
    </div>

    <div class="middle-line flex align-items-center">
      <Skeleton width="25%" height="1rem" class="bg-gray-dark" />
      <i aria-hidden="true" class="pi pi-arrow-right text-gray-darker" />
      <Skeleton width="25%" height="1rem" class="bg-gray-dark" />
    </div>

    <div class="bottom-line flex flex-column align-items-start">
      <Skeleton width="50%" height="1rem" class="bg-gray" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import Skeleton from 'primevue/skeleton';
</script>

<style>
.quick-search-result {
  gap: var(--sp-1);
  padding: var(--sp-3);
  border-bottom: 1px solid var(--p-surface-300);

  .p-skeleton {
    &.bg-gray {
      background-color: var(--p-surface-200);
    }

    &.bg-gray-dark {
      background-color: var(--p-surface-300);
    }

    &.bg-gray-darker {
      background-color: var(--p-surface-400);
    }
  }

  .middle-line {
    gap: var(--sp-1);
  }

  i.pi {
    font-size: 10px;
  }
}
</style>
